import React from 'react';

const CardButton = ({ text, onClick, className = '' }) => {
  return (
    <button
      onClick={onClick}
      className={`w-full sticky bottom-4 bg-white text-gray-800 text-sm p-2 rounded-xl font-medium 
      border border-gray-200 hover:border-gray-300 hover:bg-gray-50 
      active:scale-[0.98] transition-all duration-200 
      shadow-sm hover:shadow backdrop-blur-sm ${className}`}
    >
      {text}
    </button>
  );
};

export default CardButton;
